var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ loaderbox: !_vm.absoluteFlg, 'loaderbox-absolute': _vm.absoluteFlg }},[_c('span',{staticClass:"mdi mdi-loading mdi-spin mdi-48px"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e8a17cf","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/animations/OverlayLoading.vue
// module id = null
// module chunks = 